<script setup>
import { onMounted } from 'vue';
import { useCancelFlow } from '@/composables/cancel-flow/useCancelFlow';
import LoadingBlock from '@/components/global-themed/LoadingBlock.vue';

const props = defineProps({
  organisationId: {
    type: Number,
    required: true,
  },
  websitesWithPublishedChanges: {
    type: Array,
    default: () => [],
  },
});

const { launchCancelFlow } = useCancelFlow(props.organisationId);

onMounted(async () => {
  try {
    await launchCancelFlow();
  } catch(error) {
    console.error(error)
    window.location.href = '/settings#billing';
  }
});
</script>

<template>
  <div class="tw-m-auto tw-max-w-default-container tw-rounded-xl tw-bg-white tw-p-8 tw-text-base">
    <LoadingBlock />
    <p class="tw-mt-4 tw-text-center">
      Loading cancellation flow...
    </p>
  </div>
</template>
